import api from "PFCore/api";
import { CurrentProfile } from "PFTypes";

export const editCurrentProfile = (formData: Partial<CurrentProfile>) =>
  api<CurrentProfile>({
    method: "PUT",
    url: "me",
    data: formData
  });
